import type React from 'react';

import { Alert, Button, Text } from '@change/ds-core-ui';

import { Translate, TranslatePlural, useI18n } from '@change-corgi/core/react/i18n';

import { useDecisionMakerNotification } from './hooks/useDecisionMakerNotification';

type Props = {
	onDismiss?: () => void;
};

export const DecisionMakerRecommendation: React.FC<Props> = ({ onDismiss }) => {
	const { data, actions } = useDecisionMakerNotification({ onDismiss });
	const { translate } = useI18n();

	return (
		<Alert
			className="h-full w-full [&>div>div]:flex-row"
			variant="info"
			{...(onDismiss && {
				onDismissClick: actions.handleDismiss,
				dismissButtonAriaLabel: translate(
					'corgi.petition.starter_dashboard.notifications.dm_recommendation.dismiss_button_aria_label',
				),
			})}
			heading={
				<TranslatePlural
					value="corgi.petition.starter_dashboard.notifications.dm_recommendation.title"
					replacements={{ numDecisionMakers: data.numDecisionMakers }}
					count={data.numDecisionMakers}
				/>
			}
			data-qa="dm-recommendation-section-message"
		>
			<Text as="p">
				<Translate value="corgi.petition.starter_dashboard.notifications.dm_recommendation.body" />
			</Text>
			<Button
				className="mt-4"
				data-testid="dm-recommendation-button"
				variant="secondary-solid"
				size="x-small"
				onClick={actions.handleOpenModal}
			>
				<TranslatePlural
					value="corgi.petition.starter_dashboard.notifications.dm_recommendation.primary_action_button"
					count={1}
				/>
			</Button>
		</Alert>
	);
};
